import { verificationQueryKeys as e } from "./useVerificationQueryKeys.mjs";
import { useQuery as t } from "@maat/store-hooks";
import { verificationApi as n } from "@maat/api-main";
//#region src/verification/useIdentityVerificationQuery.ts
var r = (r = !0) => {
	let i = typeof r == "boolean" ? { enabled: r } : r;
	return t({
		queryKey: e.identity(),
		queryFn: n.getMyIdentityVerification,
		enabled: i.enabled ?? !0,
		refetchInterval: "refetchInterval" in i ? i.refetchInterval : void 0
	});
};
//#endregion
export { r as useIdentityVerificationQuery };
